module.exports = __webpack_public_path__ + "img/logo-aqua.093ccad5.jpg";